// src/pages/Sales/BroadcastPage.tsx
import { useEffect, useState } from "react";
import { socket } from "@/lib/socket";

interface WelcomeMsg { msg: string; site?: string; }
interface ChatMsg { from: string; site?: string; message: string; }
interface BroadcastSession { id: string; dealerRoom: string; role: "dealer" | "sales"; name: string; isLive: boolean; }
interface BroadcastListUpdate { broadcasts: BroadcastSession[]; }

const ROOM = "motor-ac";

const BroadcastPage = () => {
    const [messages, setMessages] = useState<string[]>([]);

    useEffect(() => {
        const onConnect = () => {
            console.log("Connected:", socket.id);
            socket.emit("joinDealer", ROOM);
            setMessages((p) => [...p, `⚡ connected as ${socket.id}, joined ${ROOM}`]);
        };

        const onWelcome = (msg: WelcomeMsg) =>
            setMessages((p) => [...p, `Server: ${msg.msg}`]);

        const onChat = (data: ChatMsg) =>
            setMessages((p) => [...p, `${data.from}: ${data.message}`]);

        const onBroadcastListUpdated = (data: BroadcastListUpdate) =>
            setMessages((p) => [...p, `Live broadcasts: ${data.broadcasts.length}`]);

        socket.on("connect", onConnect);
        socket.on("welcome", onWelcome);
        socket.on("chat", onChat);
        socket.on("broadcastListUpdated", onBroadcastListUpdated);

        return () => {
            socket.off("connect", onConnect);
            socket.off("welcome", onWelcome);
            socket.off("chat", onChat);
            socket.off("broadcastListUpdated", onBroadcastListUpdated);
        };
    }, []);

    const startBroadcast = () => {
        setMessages((p) => [...p, "▶️ startBroadcast clicked"]);
        if (!socket.connected) {
            setMessages((p) => [...p, "❌ socket not connected"]);
            return;
        }
        const payload = { dealerRoom: ROOM, role: "sales", name: "Test Broadcast" };

        // Use an ack so we know if the server actually handled it
        socket.timeout(5000).emit("startBroadcast", payload, (err: unknown, res?: { ok: boolean; reason?: string }) => {
            if (err) {
                setMessages((p) => [...p, `❌ startBroadcast timeout/no handler`]);
                console.error("startBroadcast ack error:", err);
                return;
            }
            if (res?.ok) {
                setMessages((p) => [...p, "✅ broadcast started"]);
            } else {
                setMessages((p) => [...p, `⚠️ server rejected: ${res?.reason ?? "unknown"}`]);
            }
        });
    };

    return (
        <div className="p-6 space-y-4">
            <h1 className="text-2xl font-bold">Broadcast Panel</h1>
            <button onClick={startBroadcast} className="bg-green-600 text-white px-4 py-2 rounded">
                Start Broadcast
            </button>

            <div className="border rounded-lg p-4 h-64 overflow-y-auto bg-muted/30">
                {messages.map((m, i) => (
                    <div key={i} className="text-sm mb-1">{m}</div>
                ))}
            </div>
        </div>
    );
};

export default BroadcastPage;
